module.exports = __webpack_public_path__ + "img/13.7109961d.svg";